import React from "react";

import { FormRadioSelect } from "../../../forms/FormRadioSelect";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { reviewFormRadioChange } from "../reducers";
import { getWriteReviewFormState } from "../selectors";

export const WriteReviewFormRadioField = (props: {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}): React.ReactNode => {
    const dispatch = useAppDispatch();

    const formState = useAppSelector((rootState) =>
        getWriteReviewFormState(rootState.reviews, props),
    );

    const value = formState?.valuesText[props.name] ?? "";
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        dispatch(
            reviewFormRadioChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
                isChecked: e.currentTarget.checked,
            }),
        );
    };

    const choices = props.field.options.map((option) => {
        return {
            value: option,
            label: option,
        };
    });

    return (
        <FormRadioSelect
            name={`${props.name}-${props.formUUID}`}
            id={`${props.name}-${props.formUUID}`}
            required={props.field.is_required}
            label={props.field.name}
            labelPlacement={"static"}
            legend="Recommendations"
            choices={choices}
            onChange={onChange}
            value={value}
            errors={errors}
            showErrorMessages={showErrors}
        />
    );
};
